import React from 'react'
import {graphql, useStaticQuery} from 'gatsby'
import gatsbylogo from '../images/gatsby-icon.png'
import * as footerStyles from './componentStyles/footer.module.scss'
const Footer = () => {
    const currYear = new Date().getFullYear();
    const data = useStaticQuery(graphql`
    query{
        site{
            siteMetadata{
                author
            }
        }
        }
    `)
    return (
        <footer className={footerStyles.footer}>
            <p>
                created by <span style={{fontWeight:'bold'}}>{data.site.siteMetadata.author}</span>;  powred by <span style={{fontWeight:'bold'}}><img width={18} height={18} style={{verticalAlign:'middle'}} alt="gatsbyjs" src={gatsbylogo} /> gatsby</span> © {currYear}
            </p>
        </footer>
    )
}

export default Footer
